<template>
  <div class='cm-location-filter'>
    <span class='cm-location-filter__location-icon'>location</span>

    <input
      class='cm-location-filter__input'
      type="text"
      ref="input"
      v-model="searchText"
      placeholder="Location"
      autocomplete="off"
    />

    <span class='cm-location-filter__separator' />

    <div class="cm-location-filter__radius">
      <select
        class='cm-location-filter__radius-select'
        :value="radius"
        @input="$emit('radius', $event.target.value)"
      >
        <option
          v-for="mile in miles"
          :key="mile"
          :value="`${mile} miles`"
        >{{`${mile} miles`}}</option>
      </select>
      <div class="cm-location-filter__radius-arrow">navigatedown</div>
    </div>
  </div>
</template>

<script>
import GoogleMapsLoader from "../lib/google-maps";

export default {
  props: {
    location: {
      type: String
    },
    coords: {
      type: Object
    },
    radius: {
      type: String
    }
  },

  data() {
    return {
      searchText: this.location,
      miles: [5, 10, 25, 50],
      radius: "5 miles"
    };
  },

  mounted() {
    GoogleMapsLoader.load(google => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.$refs.input,
        {
          types: ["geocode"],
          fields: ["name", "geometry.location", "formatted_address"]
        }
      );

      google.maps.event.addListener(autocomplete, "place_changed", () => {
        let place = autocomplete.getPlace();

        if (place.name !== "" && place.geometry) {
          this.$emit("location", place.formatted_address);
          this.$emit("coords", {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          });
        } else {
          this.$emit("location", "");
          this.$emit("coords", { lat: null, lng: null });
        }
      });
    });
  },

  watch: {
    location(nextValue) {
      this.searchText = nextValue;
    }
  }
};
</script>

<style lang='scss' scoped>
.cm-location-filter {
  @extend %b1;
  position: relative;
  display: flex;
  min-width: 10rem;
  background: var(--bg-2);
  border-radius: $radius;
  height: 2rem;

  &__input {
    background: none;
    padding: 0 0.5rem 0 1.5rem;
    flex: 1 1 auto;
    width: 72px;
  }

  &__radius-label {
    @extend %b1;
    color: var(--fg-2);
  }

  &__separator {
    opacity: 0.5;
    border-left: 2px solid var(--fg-2);
    margin: 0.5rem 0;
  }

  &__location-icon {
    color: var(--fg-2);
    font-family: "SSStandard";
    @extend %b2;
    position: absolute;
    top: 50%;
    left: 0.5rem;
    pointer-events: none;
    transform: translateY(calc(-50% + 0.1rem));
  }

  &__radius {
    position: relative;
    color: inherit;

    &-select {
      display: inline-block;
      padding: 0 1.5rem 0 0.5rem;
      width: 100%;
      margin: 0;
      line-height: 1;
      background: none;
      border: 0;
      border-radius: 0.25rem;
      cursor: pointer;
      outline: 0;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      font-weight: inherit;
      height: 100%;
      color: var(--fg-2);
    }

    &-arrow {
      font-family: $ff_icon;
      color: var(--fg-2);
      border-radius: 50%;
      font-size: 0.6rem;
      line-height: 1;
      padding-top: 3px;
      position: absolute;
      right: 12px;
      top: 12px;
      pointer-events: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/location-filter.vue?73321873